import config from "@/config/domain";
const report1 = config.oldWebUrl + "reports/myreports/subscription";

export enum HeaderEnum {
  PRODUCT_EQUITY = "/products/equity",
  FIXED_INCOME = "/products/fixed-income/bonds",
  FIXED_INCOME_NCD = "/",
  FIXED_INCOME_CORPFD = "/products/corporate-fd",
  FIXED_INCOME_54ACBONDS = "/products/capital-gains-bonds",
  ALTERNATIVE_SPMLD = "/products/mld",
  ALTERNATIVE_SGB = "/products/sgb",
  MANGED_PORTFOLIO_MF = "/products/managed-portfolio/mutualfunds",
  MANGED_PORTFOLIO_ETF = "products/managed-portfolio/etf",
  MANGED_PORTFOLIO_SMALLCASE = "/",
  MANGED_PORTFOLIO_PICKRIGHT = "/",
  CORP_FD = "/",
  SGB = "/sgb",
  CORP_FD_PRODUCT = "/products/corporate-fd",
  CORP_FD_ORDERBOOK = "/corporate-fd/orderbook",
  SEC_MARKET_EQUITY = "/products/equity",
  SEC_MARKET_CURRENCY = "/",
  INSURANCE_GENERAL = "/insurance",
  INSURANCE_LIFE = "/insurance",
  EQUITY = "/markets/equity",
  EQUITY_DRIVING_MARKET = "/markets/equity?sectionName=drivingMarket",
  EQUITY_STOCKUPGRADE_DOWNGRADE = "/markets/equity?sectionName=stocksUnderSurveillanceWrap",
  EQUITY_INSIDER_TRADING = "/markets/equity?sectionName=insiderTradingAndSast",
  EQUITY_EVENTCALENDAR = "/event-calendar/CALENDAR_HOME",
  EQUITY_EVENTCALENDAR_ALL_EVENTS = "/event-calendar/ALL_EVENTS_LISTING",
  FUTURE = "/markets/futures",
  FUTURE_SPOT_COMPARATIVE = "/markets/futures?sectionName=futures-spotcomparative",
  FUTURE_OI_ANALYSIS = "/markets/futures?sectionName=futures-openinterestanalysis",
  FUTURE_SECURITY_FNO_BAN = "/markets/futures?sectionName=futures-securitiesinfandoban",
  OPTIONS = "/markets/options",
  OPTIONS_CHAIN_TOOL = "/option-chain-tool",
  OPTIONS_CHAIN = "/markets/options?sectionName=callput-tableblock",
  OPTIONS_OICHART = "/markets/options?sectionName=oi-charts",
  OPTIONS_ADVANCED_CHAIN = "/markets/options?sectionName=AdvancedOptionTools",
  MUTUAL_FUND = "/markets/mutualFunds",
  MUTUAL_FUND_TOPPERFORMING = "/markets/mutualFunds?sectionName=TopPerformingFunds",
  MUTUAL_FUND_IDEASFORINVESTMENT = "/markets/mutualFunds?sectionName=IdeasforInvestment",
  MUTUAL_FUND_GROWTH_CALCULATOR = "/markets/mutualFunds?sectionName=MfCalculator",
  MUTUAL_FUND_EXPLORE_ALL_FUNDS = "/markets/mutualFunds?sectionName=ExploreAllFunds",
  OTHERS_ETF = "/markets/etfs",
  OTHERS_OFS_BUYS_RIGHTS = "/corporate-action",
  SECONDARY_NCD = "/markets/ncds",
  OTHERS_CORP_FD = "/corporate-fd",
  IPO = "/markets/primaryMarket/ipo",
  IPO_LIVES = "/markets/primaryMarket/ipo?sectionName=live-ipos",
  IPO_TOBE_ANNOUNCED = "/markets/primaryMarket/ipo?sectionName=upcoming-ipos",
  IPO_UPCOMING = "/markets/primaryMarket/ipo?sectionName=upcoming-ipos",
  IPO_LISTING_PERFORMANCE = "/markets/primaryMarket/ipo?sectionName=ListingPerformance",
  NCD = "/markets/primaryMarket/ncd-ipo",
  NCD_IPO_LIVES = "/markets/primaryMarket/ncd-ipo",
  NCD_IPO_UPCOMING = "/markets/primaryMarket/ncd-ipo",
  NFO = "/markets/primaryMarket/nfo",
  NFO_LIVES = "/markets/primaryMarket/nfo",
  NFO_UPCOMING = "/markets/primaryMarket/nfo",
  NFO_LISTING_PERFORMANCE = "/markets/primaryMarket/nfo",
  OPTION_CHAIN_INSIDER_SAST = "/",
  OPTION_CHAIN_MARGIN_CALCULATOR = "/margin-calculator",
  OPTION_CHAIN_EVENT_CALENDAR = "/event-calendar",
  ALERTS_TRADING_AREA = "/watchlist",
  ALERTS_LIVE_NEWS = "/live-news",
  ALERTS_ALPHA = "/",
  DASHBOARD_REPORT = "/newreports/dashboard",
  HOLDINGS_REPORT = "/newreports/holding",
  PROFITLOSS_REPORT = "/newreports/profitandloss",
  TAX_REPORT = "/newreports/tax",
  TRANSACTION_HISTORY_REPORT = "/newreports/transaction-history",
  MARGINS_REPORT = "/newreports/otherReports?tab=margin-report",
  LEADGER_REPORT = "/newreports/otherReports?tab=ledger-report",
  COMMODITY = "/commodity/:symbol",
  ALERTS = "/alerts",
  PLACEORDER = "/",
  MARGIN_FILES = "/margin-files",
  AUTHORIZE_TO_SELL = "/authorize-sell",
  PLEDGE = "/epledges",
  FUND_TRANSFER = "/fund-transfer",
  ORDERBOOK = "/orderbook",
  SEE_MARGIN = "/",
  WATCHLIST = "/watchlist",
  EVOTING = "/",
  EDIS = "/edis",
  EQUITY_SIP_BOOK = "/",
  MF_SIP_BOOK = "/",
  SEARCH = "/search",
  POSITION = "/newreports/positions",

  // new links
  FIXED_INCOME_NCD_NFO = "/products/fixed-income/bonds",
  FIXED_INCOME_SECONDARYPRODUCTS = "/products/fixed-income/debentures",
  FIXED_INCOME_CORPORATE_FD = "/products/fixed-income/CorpFD",
  FIXED_INCOME_54EC_BONDS = "/products/fixed-income/54ec-bonds",
  FIXED_INCOME_RBI_BONDS = "/products/fixed-income/rbi-bonds",
  FIXED_INCOME_SGB = "/products/fixed-income/sgb",

  SECONDARY_MARKETS_EQUITY = "/products/exchange-traded/equity",
  SECONDARY_MARKETS_CURRENCY = "/products/exchange-traded/currency",
  SECONDARY_MARKETS_COMMODITY = "/products/exchange-traded/commodity",
  SECONDARY_MARKETS_SUB_FEE_INFINITY = "/products/exchange-traded/infinity-subscription",

  MANAGED_PORTFOLIO_AIF = "/products/managed-portfolio/aif",
  MANAGED_PORTFOLIO_PMS = "/products/managed-portfolio/pms",
  MANAGED_PORTFOLIO_MUTUALFUNDS = "/products/managed-portfolio/mutualfunds",
  MANAGED_PORTFOLIO_ETF = "/products/managed-portfolio/etf",
  MANAGED_PORTFOLIO_SP = "/products/managed-portfolio/structured-product",

  SOLUTION_LIFE_INSURANCE = "/products/insurance/life-insurance",
  SOLUTION_GENERAL_INSURANCE = "/products/insurance/general-insurance",

  NRI_OFFERINGS = "/products/nrioffering",
  LEGANCY_PLANNING = "/products/legacy",

  ASSET_INSURANCE = "/products/insurance",

  ASSET_MANAGED_PORTFOLIO = "/products/managed-portfolio",

  ASSET_CAPITAL_MARKETS = "/products/exchange-traded",

  ASSET_FIXED_INCOME = "/products/fixed-income",

  MARKET_EQUITY = "/markets/equity",
  MARKET_FUTURES = "/markets/futures",
  MARKET_OPTIONS = "/markets/options",
  MARKET_MUTUALfUNDS = "/markets/mutualFunds",
  MARKET_ETF = "/markets/etfs",
  PRIMARYMARKETS_IPO = "/markets/primaryMarket/ipo",
  PRIMARYMARKETS_NCD_IPO = "/markets/primaryMarket/ncd-ipo",
  PRIMARYMARKETS_NFO = "/markets/primaryMarket/nfo",

  // RESOURCES_OPTIONCHAIN = "/markets/options",
  RESOURCES_LIVENEWS = "/live-news",

  OTHEROFFERING_PICKRIGHT = "/",
  OTHEROFFERING_SMALLCASE = "/",

  SUPPORT_CONTACT = "/",
  SUPPORT_ACCOUNTOPENING_STATUS = "",
  SUPPORT_NOTICE_FORMS_FORMATS = "/important-messages",

  REPORT_DASHBORAD = "/newreports/dashboard",
  REPORT_HOLDING = "/newreports/holding",
  REPORT_PROFIT_LOSS = "/newreports/profitandloss",
  REPORT_TAX = "/newreports/tax",
  REPORT_TRANSACTION_HISTORY = "/newreports/transaction-history",
  REPORT_MARGINS = "/newreports/otherReports?tab=margin-report",
  REPORT_LEDGER = "/newreports/otherReports?tab=ledger-report",
  REPORT_CONTRACT_NOTES = "/newreports/otherReports?tab=contract-notes",
  REPORT_EQUITY_SIP = "",
  REPORT_MF_SIP = "",
  REPORT_PENDING_LTCG = "",
  REPORT_PAYMENT_INTERACTION = "/newreports/otherReports?tab=delayed-payment-interest",
  REPORT_DPBILLS = "/newreports/otherReports?tab=dpbills",
  REPORT_SUBSCRIPTIONFEES = "/newreports/otherReports?tab=subscription-history",

  TRANSACT_PLACE_ORDER = "",
  TRANSACT_fUNDTRANSFER = "",
  TRANSACT_POSITION = "",
  TRANSACT_ORDER_BOOK = "",
  TRANSACT_SEE_MARGINS = "",
  TRANSACT_AUTHORIZETOSELL = "",
  TRANSACT_PLEDGE = "",
  TRANSACT_E_VOTING = "",
  TRANSACT_MARGIN_FILES = "",
  CONTRACT_NOTE = "/newreports/otherReports?tab=contract-notes",
  DP_BILLS = "/newreports/otherReports?tab=dpbills",
  DP_INTEREST = "/newreports/otherReports?tab=delayed-payment-interest",
  SUBSCRIPTION_HISTORY = "/newreports/otherReports?tab=subscription-history",
}
